import { render } from "./BarButtonColor.vue?vue&type=template&id=f094c3d0&scoped=true"
import script from "./BarButtonColor.vue?vue&type=script&lang=js"
export * from "./BarButtonColor.vue?vue&type=script&lang=js"

import "./BarButtonColor.vue?vue&type=style&index=0&id=f094c3d0&scoped=true&lang=css"

import exportComponent from "/Users/romain/Developer/vue-file-toolbar-menu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f094c3d0"]])

export default __exports__